import { splitSentences, tokenize } from "./tokenize";
import { replaceSynonym } from "./synonyms";
import { caseMistake, commaMistakes, typo } from "./mistakes";
import { insertFiller } from "./fillers";
import { sentenceNoise } from "./sentences";
import { createDeterministicRandom } from "./random";

export const STUDENT_PROFILES = {
  klasse7: {
    synonymChance: 0.22,
    caseChance: 0.2,
    typoChance: 0.14,
    commaChance: 0.34,
    fillerChance: 0.35,
    sentenceNoiseChance: 0.3
  },
  klasse9: {
    synonymChance: 0.3,
    caseChance: 0.13,
    typoChance: 0.1,
    commaChance: 0.26,
    fillerChance: 0.22,
    sentenceNoiseChance: 0.2
  },
  oberstufe: {
    synonymChance: 0.38,
    caseChance: 0.06,
    typoChance: 0.06,
    commaChance: 0.16,
    fillerChance: 0.12,
    sentenceNoiseChance: 0.1
  }
};

function normalizeProfile(profileName) {
  return STUDENT_PROFILES[profileName] || STUDENT_PROFILES.klasse9;
}

export function processText(inputText, profileName = "klasse9") {
  if (!inputText || !inputText.trim()) {
    return "";
  }

  const profile = normalizeProfile(profileName);
  const random = createDeterministicRandom(`${profileName}::${inputText}`);
  const sentences = splitSentences(inputText);

  const transformed = sentences.map((sentence) => {
    const tokens = tokenize(sentence).map((token) => {
      let updated = replaceSynonym(token, random, profile.synonymChance);
      updated = caseMistake(updated, random, profile.caseChance);
      updated = typo(updated, random, profile.typoChance);
      return updated;
    });

    let merged = tokens.join("");
    merged = insertFiller(merged, random, profile.fillerChance);
    merged = sentenceNoise(merged, random, profile.sentenceNoiseChance);
    return merged;
  });

  return commaMistakes(transformed.join(" "), random, profile.commaChance);
}
